import { render } from "./menuPage.vue?vue&type=template&id=d66ed7b2"
import script from "./menuPage.vue?vue&type=script&lang=js"
export * from "./menuPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__